module.exports = __webpack_public_path__ + "static/rice-university-anne-charles-duncan-hall-1-cd21e471834bbe1f3d34e7df9eb47e89.jpg";